import React, { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PageTitle from "../layouts/PageTitle";
import { Formik } from "formik";
import * as Yup from "yup";
import { Fn_AddEditData, Fn_DisplayData, Fn_FillListData } from "../../store/Functions";
import { useDispatch } from "react-redux";
import { API_WEB_URLS } from "../../constants/constAPI";

const AllowanceSchema = Yup.object().shape({
  Name: Yup.string().required("Allowance name is required"),
  F_FirmMaster: Yup.number().required("Firm is required"),
  Ordering: Yup.number().required("Ordering is required"),
});

const AddEdit_AllowanceMaster = () => {
  const [state, setState] = useState({
    id: 0,
    formData: {
      Name: "",
      F_FirmMaster: "",
      Ordering: "",
      IsActive: true,
      IsApplicable: false,
    },
    FirmMaster: [],
    isProgress: false,
  });

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const API_URL_SAVE = "AllowanceMaster/0/token";
  const API_URL_EDIT = `${API_WEB_URLS.MASTER}/0/token/AllowanceMaster/Id`;

  useEffect(() => {
    Fn_FillListData(dispatch, setState, "FirmMaster", `${API_WEB_URLS.MASTER}/0/token/FirmMaster/Id/0`);
    const Id = (location.state && location.state.Id) || 0;
    if (Id > 0) {
      setState((prev) => ({ ...prev, id: Id }));
      Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT);
    }
  }, [dispatch, location.state]);

  const handleSubmit = async (values) => {
    try {
      const formData = new FormData();
      formData.append("Name", values.Name);
      formData.append("F_FirmMaster", values.F_FirmMaster);
      formData.append("Ordering", values.Ordering);
      formData.append("IsActive", values.IsActive ? true : false);
      formData.append("IsApplicable", values.IsApplicable ? true : false);

      Fn_AddEditData(
        dispatch,
        setState,
        { arguList: { id: state.id, formData } },
        API_URL_SAVE,
        true,
        "memberid",
        navigate,
        "/AllowanceMaster"
      );
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("An error occurred while submitting the form. Please try again.");
    }
  };

  return (
    <Fragment>
      <PageTitle activeMenu="Masters" motherMenu="Masters" pageContent="Allowance Master" />

      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Allowance Master</h4>
            </div>
            <div className="card-body">
              <div className="basic-form">
                <Formik
                  initialValues={state.formData}
                  enableReinitialize
                  validationSchema={AllowanceSchema}
                  onSubmit={(values, { setSubmitting }) => {
                    setTimeout(() => {
                      handleSubmit(values);
                      setSubmitting(false);
                    }, 400);
                  }}
                >
                  {({ values, errors, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label className="text-label">Allowance Name *</label>
                          <input
                            type="text"
                            className="form-control"
                            name="Name"
                            value={values.Name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          {errors.Name && <div className="text-danger fs-12">{errors.Name}</div>}
                        </div>

                        <div className="col-md-6 mb-3">
                          <label className="text-label">Firm *</label>
                          <select
                            className="form-control"
                            name="F_FirmMaster"
                            value={values.F_FirmMaster}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            <option value="">-- Select Firm --</option>
                            {state.FirmMaster.map((f) => <option key={f.Id} value={f.Id}>{f.Name}</option>)}
                          </select>
                          {errors.F_FirmMaster && <div className="text-danger fs-12">{errors.F_FirmMaster}</div>}
                        </div>

                        <div className="col-md-6 mb-3">
                          <label className="text-label">Ordering *</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Ordering"
                            value={values.Ordering}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          {errors.Ordering && <div className="text-danger fs-12">{errors.Ordering}</div>}
                        </div>

                        <div className="col-md-6 mb-3 d-flex align-items-center mt-4">
                          <div className="form-check me-4">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="IsActive"
                              name="IsActive"
                              checked={!!values.IsActive}
                              onChange={(e) => setFieldValue("IsActive", e.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="IsActive">
                              Is Active
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="IsApplicable"
                              name="IsApplicable"
                              checked={!!values.IsApplicable}
                              onChange={(e) => setFieldValue("IsApplicable", e.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="IsApplicable">
                              Is Applicable
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="mt-3">
                        <button type="submit" className="btn btn-primary me-2" disabled={isSubmitting}>
                          {isSubmitting ? "Saving..." : "Save"}
                        </button>
                        <button
                          type="button"
                          className="btn btn-danger light"
                          onClick={() => navigate("/AllowanceMaster")}
                        >
                          Cancel
                        </button>
                      </div>
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AddEdit_AllowanceMaster;
